import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckTickDouble = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.63123 8.21833L4.75282 11.3366L5.00222 10.9005C5.31575 10.3523 5.6575 9.82239 6.02567 9.31284C7.22781 7.64907 8.71165 6.20185 10.4146 5.03899L10.9646 4.66345M14.3687 5.07257L13.7888 5.39995C11.4431 6.7242 9.4287 8.56369 7.89737 10.7797L7.61177 11.193L7.4135 10.958",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCheckTickDouble);
export default ForwardRef;
